export const TimeFormatRegex = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/



// WEBPACK FOOTER //
// ./src/settings/regex.js